import { render, staticRenderFns } from "./SlideDeckAssignResourcesToPage.modal.vue?vue&type=template&id=58025011"
import script from "./SlideDeckAssignResourcesToPage.modal.vue?vue&type=script&lang=ts"
export * from "./SlideDeckAssignResourcesToPage.modal.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckAssignResourcesToPage.modal.vue?vue&type=style&index=0&id=58025011&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports